import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { QUOTES } from "../content.js";

export const Testimonials = ({ accent }) => (
  <section id="testimonials" style={{ background: C.bg, padding: "140px 40px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div style={{ marginBottom: 48 }}>
        <SectionLabel accent={accent}>// SAID ABOUT US</SectionLabel>
        <h2
          style={{
            margin: "14px 0 0",
            fontFamily: fonts.serif,
            fontSize: "clamp(36px, 4.4vw, 56px)",
            fontWeight: 500,
            color: C.fg,
            letterSpacing: "-0.01em",
            lineHeight: 1.05,
          }}
        >
          Words from the <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>teams we ship with.</em>
        </h2>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: 20,
        }}
      >
        {QUOTES.map((t, i) => (
          <figure
            key={i}
            style={{
              margin: 0,
              background: C.card,
              border: `1px solid ${C.border}`,
              borderRadius: 8,
              padding: "32px 28px",
              display: "flex",
              flexDirection: "column",
              gap: 22,
              position: "relative",
            }}
          >
            <div
              style={{
                fontFamily: fonts.serif,
                fontStyle: "italic",
                fontSize: 64,
                color: accent,
                lineHeight: 0.6,
                height: 22,
              }}
            >
              “
            </div>
            <blockquote
              style={{
                margin: 0,
                fontFamily: fonts.serif,
                fontSize: 19,
                fontStyle: "italic",
                color: C.fg,
                lineHeight: 1.45,
                fontWeight: 400,
                letterSpacing: "-0.005em",
              }}
            >
              {t.q}
            </blockquote>
            <figcaption style={{ display: "flex", alignItems: "center", gap: 14, marginTop: "auto" }}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 999,
                  background: `linear-gradient(135deg, ${accent}55, ${accent}11)`,
                  border: `1px solid ${accent}55`,
                  display: "grid",
                  placeItems: "center",
                  fontFamily: fonts.serif,
                  fontSize: 16,
                  fontWeight: 600,
                  color: accent,
                }}
              >
                {t.n.split(" ").map((p) => p[0]).join("")}
              </div>
              <div>
                <div style={{ fontFamily: fonts.sans, fontSize: 13, color: C.fg, fontWeight: 600 }}>{t.n}</div>
                <div style={{ fontFamily: fonts.mono, fontSize: 11, color: C.body, letterSpacing: "0.04em" }}>
                  {t.r}
                </div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
